import React, { useContext } from 'react'
import { View, Text, StyleSheet } from 'react-native'

import {
  BG_STYLES,
  BORDER_STYLES,
  COLORS,
  COMMON_STYLES,
  Label,
  LazyImage,
  TEXT_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from '@dehaat/dds'
import { ResponsiveContext } from 'app/context/ResponsiveUIContext'
import { DIMENSION_WIDTH } from 'app/utils/common'

interface Props {
  cropName: string
  cropImageUrl: string | null
  sowingDate: string | null
  farmName: string | null
}

const CropCard = ({ cropImageUrl, cropName, sowingDate, farmName }: Props) => {
  const { mediaStyles } = useContext(ResponsiveContext)
  return (
    <View
      style={[
        COMMON_STYLES.b1,
        BORDER_STYLES.borderNeutral10,
        COMMON_STYLES.p1,
        BG_STYLES.bgNeutral00,
        COMMON_STYLES.br1,
        COMMON_STYLES.row,
        COMMON_STYLES.relative,
        styles.ml42,
        mediaStyles({ mobileStyle: { width: DIMENSION_WIDTH - 96 } }),
      ]}
    >
      <View style={[COMMON_STYLES.flex1, styles.ml42]}>
        <Text
          style={[
            TYPOGRAPHY.HEADING3,
            VARIANTS_STYLES.MEDIUM,
            TEXT_STYLES.textNeutral100,
          ]}
        >
          {cropName}
        </Text>
        <Text
          style={[
            TYPOGRAPHY.TEXT2,
            VARIANTS_STYLES.MEDIUM,
            TEXT_STYLES.textNeutral80,
            COMMON_STYLES['mt1/2'],
          ]}
        >
          Sowing: {sowingDate || '-'}
        </Text>
        <Text
          style={[
            TYPOGRAPHY.TEXT2,
            VARIANTS_STYLES.MEDIUM,
            TEXT_STYLES.textNeutral80,
            COMMON_STYLES['mt1/2'],
          ]}
        >
          Farm: {farmName || '-'}
        </Text>
      </View>
      <View style={COMMON_STYLES.ml1}>
        <Label
          text={'Ongoing'}
          bgColor="bgSuccess100"
          textColor="textWhite"
          containerStyle={COMMON_STYLES['br1/4']}
        />
      </View>
      <LazyImage
        imageUrl={cropImageUrl}
        imgStyles={styles.cropImage}
        fallBackIcon={
          <View style={[styles.cropImage, styles.noImage]}>
            <Text style={styles.noImgTextOverImg}>{cropName[0]}</Text>
          </View>
        }
      />
    </View>
  )
}

const styles = StyleSheet.create({
  ml42: {
    marginLeft: 42,
  },
  cropImage: {
    position: 'absolute',
    height: 84,
    width: 84,
    borderRadius: 42,
    borderWidth: 1,
    borderColor: COLORS.neutral10,
    left: -42,
    top: 21,
    zIndex: 1,
    backgroundColor: COLORS.white,
  },
  noImage: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: COLORS.white,
  },
  noImgTextOverImg: {
    fontSize: 36,
    lineHeight: 40,
    fontWeight: '600',
    color: COLORS.black,
  },
})

export default CropCard
